import React, { useState } from "react";
import CalculatorCard from "../../components/CalculatorCard";
import PageSeo from "../../components/PageSeo";
import { Helmet } from "react-helmet-async";

export default function MaintenanceCostCalculator() {
  const [servicesPerYear, setServicesPerYear] = useState("3");
  const [serviceCost, setServiceCost] = useState("");
  const [monthlyFuel, setMonthlyFuel] = useState("");
  const [consumables, setConsumables] = useState("");
  const [result, setResult] = useState(null);

  const calculateMaintenance = () => {
    const annualService =
      Number(servicesPerYear || 0) * Number(serviceCost || 0);

    const annualFuel = Number(monthlyFuel || 0) * 12;
    const consumableCost = Number(consumables || 0);

    const annualTotal = annualService + annualFuel + consumableCost;

    setResult({
      annualService,
      annualFuel,
      annualTotal,
      monthlyAverage: Math.round(annualTotal / 12),
    });
  };

  const shareOnWhatsApp = () => {
    const text = encodeURIComponent(`Check my calculation result: Annual Total ₹ ${result.annualTotal} | MotoHub India https://motohubindia.com`);
    const url = window.innerWidth < 768 
      ? `whatsapp://send?text=${text}` 
      : `https://web.whatsapp.com/send?text=${text}`;
    window.open(url, '_blank');
  };

  const downloadPDF = () => {
    const el = document.getElementById('calculator-result');
    const original = document.title;
    document.title = 'MotoHub-Calculation-Result';
    window.print();
    document.title = original;
  };

  return (
    <>
      <Helmet>
        <title>Bike Maintenance Cost Calculator India | Running Cost | MotoHub India</title>
        <meta
          name="description"
          content="Calculate bike maintenance cost in India including service, fuel, and consumables. Estimate total yearly and monthly running cost."
        />
        <meta
          name="keywords"
          content="bike maintenance cost India, motorcycle running cost calculator, bike service cost India, annual bike cost calculator"
        />
        <link rel="canonical" href="https://motohubindia.com/calculator/maintenance" />
        <meta property="og:title" content="Bike Maintenance Cost Calculator | MotoHub India" />
        <meta property="og:description" content="Estimate your bike running and maintenance cost." />
        <meta property="og:url" content="https://motohubindia.com/calculator/maintenance" />
      </Helmet>

      <div style={{ padding: "30px" }}>
        <PageSeo
          title="Bike Maintenance Cost Calculator India | MotoHub"
          description="Estimate bike service, fuel, and running cost."
          path="/calculator/maintenance"
        />

        <CalculatorCard title="Maintenance Cost Calculator">
          <div style={seoBox}>
            <h2>Bike Maintenance Cost Calculator India</h2>
            <p style={seoText}>
              Use MotoHub India maintenance calculator to estimate your motorcycle’s yearly running cost. 
              This includes service expenses, fuel cost, and consumables like tyres and oil.
            </p>
            <p style={seoText}>
              This tool helps riders understand total ownership cost and plan their monthly bike expenses effectively.
            </p>
          </div>

          <input
            placeholder="Services per year"
            value={servicesPerYear}
            onChange={(e) => setServicesPerYear(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="Average service cost (Rs)"
            value={serviceCost}
            onChange={(e) => setServiceCost(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="Monthly fuel spend (Rs)"
            value={monthlyFuel}
            onChange={(e) => setMonthlyFuel(e.target.value)}
            style={inputStyle}
          />

          <input
            placeholder="Tyres, oil, chain, consumables per year (Rs)"
            value={consumables}
            onChange={(e) => setConsumables(e.target.value)}
            style={inputStyle}
          />

          <button style={buttonStyle} onClick={calculateMaintenance}>
            Calculate Annual Cost
          </button>

          <div id="calculator-result">
            {result && (
              <>
                <h3 style={{ marginTop: "20px" }}>
                  Annual Service Cost: ₹ {result.annualService.toLocaleString("en-IN")}
                </h3>
                <h3 style={{ marginTop: "10px" }}>
                  Annual Fuel Cost: ₹ {result.annualFuel.toLocaleString("en-IN")}
                </h3>
                <h3 style={{ marginTop: "10px" }}>
                  Total Annual Cost: ₹ {result.annualTotal.toLocaleString("en-IN")}
                </h3>
                <p style={noteStyle}>
                  Average monthly running cost: ₹ {result.monthlyAverage.toLocaleString("en-IN")}
                </p>
                <button onClick={shareOnWhatsApp} 
                  className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg text-sm">
                  Share on WhatsApp
                </button>
                <button onClick={downloadPDF}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg text-sm">
                  Download PDF
                </button>
              </>
            )}
          </div>
        </CalculatorCard>
      </div>
    </>
  );
}

// Styles
const inputStyle = {
  width: "100%",
  padding: "12px",
  marginBottom: "10px",
  borderRadius: "10px",
  border: "1px solid #333",
  background: "#1a1a1a",
  color: "#fff",
};

const buttonStyle = {
  width: "100%",
  padding: "12px",
  borderRadius: "10px",
  border: "none",
  background: "linear-gradient(90deg, #ff4d00, #ff7a00)",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer",
  marginTop: "10px",
};

const noteStyle = {
  marginTop: "14px",
  color: "#aaa",
  lineHeight: 1.6,
  fontSize: "14px",
};

const seoBox = {
  marginBottom: "20px",
  background: "#111",
  padding: "15px",
  borderRadius: "10px",
  border: "1px solid #222",
};

const seoText = {
  color: "#aaa",
  lineHeight: "1.6",
  marginTop: "8px",
};